import { BeltSyllabus } from './types';

export const yellowBeltGreenTag: BeltSyllabus = {
    id: 'yellow-green',
    name: 'Yellow Belt Green Tag',
    color: '#9acd32',
    theoryUnder13: [
        {
            title: 'Theory',
            items: [
                {
                    question: 'What does Do-San mean?',
                    answer: 'Do-San is named after Ahn Chang Ho, who devoted his life to Korean independence'
                },
                {
                    question: 'How many movements in Do-San?',
                    answer: '24'
                },
                {
                    question: 'What is the diagram of Do-San?',
                    answer: '/assets/diagrams/do_san_diagram.png',
                    isImage: true
                },
                {
                    question: 'What is the fourth tenet of Taekwon-Do?',
                    answer: 'Self Control'
                },
                {
                    question: 'What does Self Control mean?',
                    answer: 'To restrain oneself, to not let oneself get carried away, to stop and think before acting'
                }
            ]
        },
        {
            title: 'Korean Terms',
            items: [
                { question: 'Bending Ready Stance', answer: 'Guburyo Junbi Sogi' },
                { question: 'Circular Block', answer: 'Dollimyo Makgi' },
                { question: 'Knee', answer: 'Moorup' },
                { question: 'Sidefist', answer: 'Yop Joomok' },
                { question: 'Palm', answer: 'Sonbadak' },
                { question: 'Knifehand High Inward Strike', answer: 'Sonkal Nopundae Anuro Taerigi' },
                { question: 'Back Piercing Kick', answer: 'Dwit Cha Jirugi' },
                { question: 'Outer Forearm Inward Block', answer: 'Bakat Palmok Anuro Makgi' },
                { question: 'Free Sparring', answer: 'Jayoo Matsogi' }
            ]
        }
    ],
    theoryOver13: [
        {
            title: 'Theory',
            items: [
                {
                    question: 'What is the meaning of Do-San?',
                    answer: 'Do-San was the pseudonym of the patriot Ahn Chang Ho (1876-1938), who devoted his entire life to furthering the education of Korea and its independence movement.'
                },
                {
                    question: 'How many movements in Do-San?',
                    answer: '24'
                },
                {
                    question: 'What is the diagram of Do-San?',
                    answer: '/assets/diagrams/do_san_diagram.png',
                    isImage: true
                },
                {
                    question: 'What is an Inward Block?',
                    answer: 'An Inward Block (Anuro Makgi) is a block in which the blocking tool reaches the target on an inward trajectory to the centre line of the defender\'s body. The same applies to an Inward Strike.'
                },
                {
                    question: 'What is an Outward Block?',
                    answer: 'An Outward Block (Bakuro Makgi) is a block in which the blocking tool moves outwards, away from the centre line of the defender\'s body. The same applies to an Outward Strike.'
                },
                {
                    question: 'What is Fast Motion?',
                    answer: 'Techniques performed in Fast Motion (Parun Tongjak) are performed with a split-second pause between the end of one movement and the start of the next. The Sine Wave is performed as usual for the first movement, but the second movement only has two-thirds Sine Wave. You breath normally with one breath for each technique.'
                }
            ]
        },
        {
            title: 'Korean Terms',
            items: [
                { question: 'Bending Ready Stance', answer: 'Guburyo Junbi Sogi' },
                { question: 'Circular Block', answer: 'Dollimyo Makgi' },
                { question: 'Knee', answer: 'Moorup' },
                { question: 'Sidefist', answer: 'Yop Joomok' },
                { question: 'Palm', answer: 'Sonbadak' },
                { question: 'Knifehand High Inward Strike', answer: 'Sonkal Nopundae Anuro Taerigi' },
                { question: 'Back Piercing Kick', answer: 'Dwit Cha Jirugi' },
                { question: 'Outer Forearm Inward Block', answer: 'Bakat Palmok Anuro Makgi' },
                { question: 'Free Sparring', answer: 'Jayoo Matsogi' },
                { question: 'Sine Wave', answer: 'Hwaldung Pado' }
            ]
        }
    ],
    practical: [
        {
            title: 'Practical Elements',
            items: [
                {
                    question: 'Walking Stance Inner Forearm Circular Block',
                    answer: 'Forwards X 4'
                },
                {
                    question: 'L Stance Twin Forearm Block, Knifehand High Inward Strike, Fixed Stance Middle Punch',
                    answer: 'Forwards X 4'
                },
                {
                    question: 'Bending Ready Stance, Side Piercing Kick, land in L Stance Forearm Guarding Block',
                    answer: 'Forwards X 4'
                },
                {
                    question: 'Turning Kick, land in L Stance Forearm Guarding Block',
                    answer: 'Forwards X 4'
                }
            ]
        },
        {
            title: 'Power',
            items: [
                {
                    question: 'Back Piercing Kick',
                    answer: 'Target / Kick Shield'
                }
            ]
        },
        {
            title: 'Pattern',
            items: [
                {
                    question: 'Dan-Gun',
                    answer: ' '
                },
                {
                    question: 'Do-San',
                    answer: ' '
                }
            ]
        },
        {
            title: 'Self Defence',
            items: [
                {
                    question: 'Twin Lapel Grabs - release or deal with attacker',
                    answer: 'Under 13\'s'
                },
                {
                    question: 'Backhand / Backfist Strikes / Hidden Weapon',
                    answer: 'All Ages'
                },
                {
                    question: 'Situational - Turning Kicks (Low) - (Block / Dodge)',
                    answer: 'All Ages'
                }
            ]
        },
        {
            title: 'Sparring',
            items: [
                {
                    question: 'Three-Step Sparring',
                    answer: 'Sequences 1-5'
                },
                {
                    question: 'Free Sparring',
                    answer: 'Combinations of Attacks, Foot and Hand'
                }
            ]
        }
    ]
};
